export class Origin {
  constructor(
    public hash: string,
    public name: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/origin.ts